module.exports = __webpack_public_path__ + "static/media/entregapapas.96a8818f.webp";